<template>
    <div>
        <CreateAuthorAccountForm
            v-if="active_form == 'register'"
            :emit_switch_to_sign_up="true"
            @switchForm="active_form = 'log-in'"
        />

        <LogInForm
            v-if="active_form == 'log-in'"
            @switchForm="active_form = 'register'"
            @showOtpConfirmation="showOtpConfirmationForm"
            :redirect_to_wizard="true"
        />

        <OtpConfirmationForm
            v-if="active_form == 'otp-confirmation'"
            :otp_email="otp_email"
            @switchForm="active_form = 'register'"
        />
    </div>
</template>

<script>
import CreateAuthorAccountForm from "./CreateAuthorAccountForm.vue";
import LogInForm from "./LogInForm.vue";
import OtpConfirmationForm from "./OtpConfirmationForm.vue";

export default {
    components: { CreateAuthorAccountForm, LogInForm, OtpConfirmationForm },

    data() {
        return {
            active_form: "register", // register / log-in / otp-confirmation
            otp_email: "coco@bango.com",
        };
    },

    methods: {
        showOtpConfirmationForm(email) {
            this.otp_email = email;
            this.active_form = "otp-confirmation";
        },
    },
};
</script>
